import "../styles/IndicatorsStyle.css";

import { useState, useEffect } from "react";

import { filter_wms_by_boundary, months } from "../sidepane/SidePanel";
import DroughtIndicatorModal from "./DroughtIndicatorModal";
import { get_data} from "../Geoportal";
import { get_custom_list, get_info_element } from "./Indicators";
import {set_innitial_selected_datasets_with_timescale} from "./PrecipitationUtils";
import {set_innitial_selected_datasets_longrange} from "./longrange_forecast";
import {handleInfoClickGeneral, selection_component, oncheckGeneral, selection_component_general_longrange } from "./Utils"
export function getMonthName(monthNumber) {
  const months_list = Object.keys(months);
  return months_list[monthNumber - 1];

}

export function handle_wmslink(
  wms_link,
  cell_column,
  selected_country,
  selected_region
) {
  if (selected_country !== null) {
    wms_link = filter_wms_by_boundary(
      wms_link,
      selected_country["country_id"],
      cell_column,
      1
    );
    return wms_link;
  }
  if (selected_region === null && selected_country === null) {
    return wms_link;
  }
  if (selected_region !== null && selected_country === null) {
    wms_link = filter_wms_by_boundary(
      wms_link,
      selected_region,
      cell_column,
      0
    );
    return wms_link;
  }
}

// handles data selected
export function handle_selected_data(array_selection, pre_selected) {

  if (array_selection.includes(pre_selected)) {
    return pre_selected;
  } else {
    return array_selection[0];
  }
}

export function handle_legend_url(layer_name_, geoserver, not_view=false) {
  if (not_view) {
    var legend_url = `${geoserver}REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=${layer_name_}&LEGEND_OPTIONS=border:true;dx:10;fontSize:11;`;
    return legend_url;
  }
  legend_url = `${geoserver}REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=${layer_name_}_view&LEGEND_OPTIONS=border:true;dx:10;fontSize:11;`;
  return legend_url;
}

const Precipitation = ({
  get_select_element,
  customoptions,
  monthly_precipitation_check,
  setMonthly_recipitation_check,
  rs_data,
  precipitation_check,
  setPrecipitation_check,
  setCurrent_spi,
  setSpi_legend_url,
  months,
  selected_spi_dates,
  setSelected_spi_dates,
  get_filtered_wms_spi,
  selected_country,
  base_url,
  setCurrent_monthly_precipitation_gpcc,
  setGpcc_monthly_precipitation_legend_url,
  selected_region,
  unwdc_check,
  setUnwdc_check,
  setCurrent_unwdc,
  setCurrent_spi_era5,
  checked_spi_era5, 
  setChecked_spi_era5,
  longrange_forecast_check, 
  setLongrange_forecast_check,
  setCurrent_longrange_forecast
}) => {
  const [spi_dates, setSpi_dates] = useState({
    year: [2023, 2022, 2019],
    month: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    timescale: ["01", "03", "06", "09", "12", "24", "48"],
  });

  const [monthly_precipitation_dates, setMonthly_precipitation_dates] =
    useState({ year: ["2023", "2022", "2019"], month: ["Jan", "Feb"] });

  const [monthly_precipitation_api_data, setMonthly_precipitation_api_data] =
    useState(null);

  // precipitation forecast 

  const [unwdc_info , setUnwdc_info] = useState(null);
  const [unwdc_isLoading , setUnwdc_isLoading] = useState(false);
  const [unwdc_latest_dates , setUnwdc_latest_dates] = useState(null);
  const [isDroughtModalVisibleUnwdc , setDroughtModalVisibleUnwdc] = useState(false);
  const [unwdc_forecast_dates , setUnwdc_forecast_dates] = useState({ year: [2025],
                                            month: ["May", "Jun", "Jul", "Aug", "Sep"],
                                            timescale: ["01", "03", "06", ],
                                          });
  const [selected_unwdc_dates, setSelected_unwdc_dates] = useState({
    year: "2025",
    month: "Sep",
    timescale: "01",
  });

  // spi

  const [spi_info, setSpi_info] = useState(null);
  const [spi_latest_dates, setSpiLatestDates] = useState(null)

  const [
    selected_precipitation_monthly_dates,
    setSelectedprecipitation_monthly_dates,
  ] = useState({
    year: "2023",
    month: "Jan",
  });
  const [years_spi, setYears_spi] = useState([]);
  var geoserver = `${base_url}/geoserver/wms?`;
  let now = new Date();
  let current_year = now.getFullYear();
  let current_month = now.getMonth() + 1;

  var maplibre_str =
    "bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&width=256&height=256&transparent=true&layers=";
  var layer_name = "africa_drought_datasets:grid_1dd_spi_";
  const [layer_name_monthly_precipitation] = useState("africa_drought_datasets:grid_1dd_gpcc_mon_rain_");
  const [layer_name_unwdc] = useState("africa_drought_datasets:grid_1dd_unwdc_");
  const [guess_monthly_precip_name] = useState("africa_drought_datasets:grid_1dd_gpcc_guess_rain_");

  const [isDroughtModalVisibleSpi, setDroughtModalVisibleSpi] = useState(false)

  const [IsLoadingSpiInfo, setIsLoadingSpiInfo] = useState(false)
  const [monthlyPrecipInfo, setMonthlyPrecipInfo] = useState(null)
  const [isDroughtModalVisibleMonthlyPrecip, setDroughtModalVisibleMonthlyPrecip] = useState(false)
  const [IsLoadingMonPrecipInfo, setIsLoadingMonPrecipInfo] = useState(false)
  
  // spi era 5

  const [layer_name_spi_era5] = useState("africa_drought_datasets:grid_025dd_spi_");
  const [isDroughtModalVisibleSpiEra5, setDroughtModalVisibleSpiEra5] = useState(false);
  const [IsLoadingSpiEra5Info, setIsLoadingSpiEra5Info] = useState(false);
  const [spiEra5Info, setSpiEra5Info] = useState(null);
  const [spi_era5_latest_dates, setSpiEra5LatestDates] = useState(null);
  const [spi_era5_dekad_active, setSpiEra5DekadActive] = useState(false);
  const [spi_era5_dates, setSpiEra5Dates] = useState({
    year: [2023, 2022, 2021],
    month: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    timescale: ["01", "03", "06", "09", "12", "24", "48"],
    dekad: ["1st", "2nd", "3rd"]
  });
  const [spi_era5_selected_dates, setSpiEra5SelectedDates] = useState({
    year: "2025",
    month: "Sep",
    timescale: "01",
    dekad: "3rd",
  });

  const list_dekads = { "1st": "01", "2nd": "11", "3rd": "21" };

  const spi_era5_timescale_with_dekads = ["01", "03"];

  function modify_wms_link(wms_link_spi) {
    if (selected_country !== null) {
      get_filtered_wms_spi(wms_link_spi, selected_country["country_id"]);
    } else {
      setCurrent_spi(wms_link_spi);
    }
  }

  //  precipitation longrange_forecast

  const [layer_name_longrange_forecast] = useState("africa_drought_datasets:data_api_forecastpolygon");
  const [isDroughtModalVisibleLongrangeForecast, setDroughtModalVisibleLongrangeForecast] = useState(false);
  const [IsLoadingLongrangeForecastInfo, setIsLoadingLongrangeForecastInfo] = useState(false);
  const [longrange_forecast_info, setLongrange_forecast_info] = useState(null);
  const [LongrangeForecast_dates, setLongrangeForecastDates] = useState({
    year: [2025,2026],
    period: ["FMA", "MAM"],
  });
  const [selected_longrange_forecast_dates, setSelected_longrange_forecast_dates] = useState({
    year: "2025",
    period: "MAM",
  });


 

  function set_innitial_selected(data) {

    var spi_data_from_api = data?.spi;
      // spi 
   
    set_innitial_selected_datasets_with_timescale(
      spi_data_from_api, layer_name,"03",
      setYears_spi, setSelected_spi_dates,
    setCurrent_spi,setSpiLatestDates, setSpi_dates, null
    )
    var spi_layer_legend = `${layer_name}${months['Jan']}03`;
    var legend_url = handle_legend_url(spi_layer_legend, geoserver);
    setSpi_legend_url(legend_url);

    // unwdc
    var unwdc_data_from_api = data?.undwc;

    set_innitial_selected_datasets_with_timescale(
      unwdc_data_from_api, layer_name_unwdc,"03",
      null, setSelected_unwdc_dates,
      setCurrent_unwdc,setUnwdc_latest_dates, setUnwdc_forecast_dates, "unwdc_geoserver"
    );
    // spi era5
    var spi_era5_data_from_api = data?.spi_era5;
    
    set_innitial_selected_datasets_with_timescale(
      spi_era5_data_from_api, layer_name_spi_era5,"03",
      null, setSpiEra5SelectedDates,
      setCurrent_spi_era5,setSpiEra5LatestDates, setSpiEra5Dates, "spi_era5_geoserver","1st"
    );

    // longrange forecast
    var longrange_forecast_data_from_api = data?.longrange_forecast;
  
    set_innitial_selected_datasets_longrange(longrange_forecast_data_from_api
      , layer_name_longrange_forecast, null , setSelected_longrange_forecast_dates, setCurrent_longrange_forecast, null, 
      setLongrangeForecastDates, "longrange_forecast_geoserver"
  )

  }

  const oncheck_precipitation_check = () => {
    setPrecipitation_check(!precipitation_check);
  };

  const oncheck_monthly_precipitation = () => {
    setMonthly_recipitation_check(!monthly_precipitation_check);
  };

  const oncheck_unwdc = () => {
    setUnwdc_check(!unwdc_check);
  };

  const onchange_year_spi = (e) => {
    var spi_months = spi_dates?.month
    var spi_timescale = spi_dates?.timescale
    if (spi_latest_dates !== null){

      if (
        parseInt(e.value, 10) !== parseInt(spi_latest_dates["latest_year"],10)
        ){
        spi_months = get_custom_list(1, 12)
        spi_months = spi_months.map(getMonthName) 
      }else{
        spi_months = get_custom_list(1, spi_latest_dates["latest_month"])
        spi_months = spi_months.map(getMonthName) 
      }
       

    }
   
    var selected_month = handle_selected_data(
      spi_months,
      selected_spi_dates["month"]
    );
    var selected_time_scale = handle_selected_data(
      spi_timescale.toString(),
      selected_spi_dates["timescale"]
    );

    var spi_geosever_link = `${geoserver}${maplibre_str}${layer_name}${months[selected_month]}${selected_time_scale}_view&CQL_FILTER=year=${e.value}`;

    // modify the wms if the country is selected
    modify_wms_link(spi_geosever_link);

    var spi_selected_dates = {
      year: e.value,
      month: selected_month,
      timescale: selected_time_scale,
    };

    setSelected_spi_dates(spi_selected_dates);

    setSpi_dates({
      year: spi_dates["year"],
      month: spi_months,
      timescale: spi_timescale,
    });
  };

  const onchange_month_spi = (e) => {
    setSelected_spi_dates({
      year: selected_spi_dates["year"],
      month: e.value,
      timescale: selected_spi_dates["timescale"],
    });
    // set current spi
    var spi_geosever_link = `${geoserver}${maplibre_str}${layer_name}${
      months[e.value]
    }${selected_spi_dates["timescale"]}_view&CQL_FILTER=year=${
      selected_spi_dates["year"]
    }`;
    modify_wms_link(spi_geosever_link);
    // setCurrent_spi(spi_geosever_link);
  };
  const onchange_time_scale_spi = (e) => {
    setSelected_spi_dates({
      year: selected_spi_dates["year"],
      month: selected_spi_dates["month"],
      timescale: e.value,
    });
    // set current spi
    var spi_geosever_link = `${geoserver}${maplibre_str}${layer_name}${
      months[selected_spi_dates["month"]]
    }${e.value}_view&CQL_FILTER=year=${selected_spi_dates["year"]}`;
    // setCurrent_spi(spi_geosever_link);
    modify_wms_link(spi_geosever_link);
  };

  const onchange_year_monthly_precipitation = (e) => {
    var months_peryear = monthly_precipitation_api_data[e.value]["months"];
    months_peryear = months_peryear.map(Number);
    months_peryear = months_peryear.map(getMonthName);
    setMonthly_precipitation_dates({
      year: monthly_precipitation_dates["year"],
      month: months_peryear,
    });
    // handle the month selected for years with no data
    var selected_month = handle_selected_data(
      months_peryear,
      selected_precipitation_monthly_dates["month"]
    );

    var selected_month = selected_month;
    var selected_year = e.value;
    var layer = `${layer_name_monthly_precipitation}${months[selected_month]}`;
    var monthly_gpcc_wms = `${geoserver}${maplibre_str}${layer}_view&CQL_FILTER=year=${selected_year}`;
    monthly_gpcc_wms = handle_wmslink(
      monthly_gpcc_wms,
      "corr_cell",
      selected_country,
      selected_region
    );
    setCurrent_monthly_precipitation_gpcc({
      monthly_precipitation_gpcc_geoserver: monthly_gpcc_wms,
    });

    setSelectedprecipitation_monthly_dates({
      year: e.value,
      month: selected_month,
    });
  };

  const onchange_month_monthly_precipitation = (e) => {
    var selected_month = e.value;
    var selected_year = selected_precipitation_monthly_dates["year"];

    if (parseInt(selected_year,10) === current_year && parseInt(months[selected_month],10) === current_month-1){
      
      
      var layer = `${guess_monthly_precip_name}${months[selected_month]}`;
      
    }else{
      layer = `${layer_name_monthly_precipitation}${months[selected_month]}`;
    }

    if (parseInt(selected_year,10) === current_year && parseInt(months[selected_month],10) === current_month-2){
      layer = `${guess_monthly_precip_name}${months[selected_month]}`;
    }

    // var layer = `${layer_name_monthly_precipitation}${months[selected_month]}`;
    var monthly_gpcc_wms = `${geoserver}${maplibre_str}${layer}_view&CQL_FILTER=year=${selected_year}`;
    monthly_gpcc_wms = handle_wmslink(
      monthly_gpcc_wms,
      "corr_cell",
      selected_country,
      selected_region
    );
   
    setCurrent_monthly_precipitation_gpcc({
      monthly_precipitation_gpcc_geoserver: monthly_gpcc_wms,
    });
    setSelectedprecipitation_monthly_dates({
      year: selected_year,
      month: e.value,
    });
  };

  const onchange_year_unwdc = (e) => {
    setSelected_unwdc_dates({
      year: e.value,
      month: selected_unwdc_dates["month"],
      timescale: selected_unwdc_dates["timescale"],
    });
    // set current unwdc
    var unwdc_geoserver_link = `${geoserver}${maplibre_str}${layer_name_unwdc}${months[selected_unwdc_dates["month"]]}${selected_unwdc_dates["timescale"]}_view&CQL_FILTER=year=${e.value}`;
    // modify_wms_link(unwdc_geoserver_link);
    setCurrent_unwdc({
      unwdc_geoserver: unwdc_geoserver_link,
    });
  };

  const onchange_month_unwdc = (e) => {
    setSelected_unwdc_dates({
      year: selected_unwdc_dates["year"],
      month: e.value,
      timescale: selected_unwdc_dates["timescale"],
    });
    // set current unwdc
    var unwdc_geoserver_link = `${geoserver}${maplibre_str}${layer_name_unwdc}${months[e.value]}${selected_unwdc_dates["timescale"]}_view&CQL_FILTER=year=${selected_unwdc_dates["year"]}`;
    // modify_wms_link(unwdc_geoserver_link);
    setCurrent_unwdc({
      unwdc_geoserver: unwdc_geoserver_link,
    });
  };

  const onchange_timescale_unwdc = (e) => {
    setSelected_unwdc_dates({
      year: selected_unwdc_dates["year"],
      month: selected_unwdc_dates["month"],
      timescale: e.value,
    });
    // set current unwdc
    var unwdc_geoserver_link = `${geoserver}${maplibre_str}${layer_name_unwdc}${months[selected_unwdc_dates["month"]]}${e.value}_view&CQL_FILTER=year=${selected_unwdc_dates["year"]}`;
    setCurrent_unwdc({
      unwdc_geoserver: unwdc_geoserver_link,
    });
  };

  // change funct spi era 5
  const handle_dekad_element_spi_era5 = (dekad)=>{
      if (!spi_era5_timescale_with_dekads.includes(dekad)){
        setSpiEra5DekadActive(false)

      }else{
        setSpiEra5DekadActive(true)
      }
  }
  const handle_geoserver_link_spi_era5 = (selected_dates)=>{
    var timescale = selected_dates?.timescale;
    
    if (spi_era5_timescale_with_dekads.includes(timescale)){
      var dekad = selected_dates?.dekad;
      if (dekad === null || dekad === undefined){
        dekad = '1st'; // default dekad
      }
      var spi_era5_geosever_link = `${geoserver}${maplibre_str}${layer_name_spi_era5}${months[selected_dates["month"]]}${list_dekads[dekad]}_${selected_dates["timescale"]}_view&CQL_FILTER=year=${selected_dates["year"]}`;
    }else {
     spi_era5_geosever_link = `${geoserver}${maplibre_str}${layer_name_spi_era5}${months[selected_dates["month"]]}_${selected_dates["timescale"]}_view&CQL_FILTER=year=${selected_dates["year"]}`;
    }
    setCurrent_spi_era5({spi_era5_geoserver:spi_era5_geosever_link});
    
  }
   

  const onchange_year_spi_era5 = (e) => {
      setSpiEra5SelectedDates(prev => ({
      ...prev,
      year: e.value
    }));
    handle_geoserver_link_spi_era5({...spi_era5_selected_dates, year: e.value})
  };
  const onchange_month_spi_era5 = (e) => {

    setSpiEra5SelectedDates(prev => ({
      ...prev,
      month: e.value
    }));
    handle_geoserver_link_spi_era5({...spi_era5_selected_dates, month: e.value})
  };
  const onchange_timescale_spi_era5 = (e) => {
    handle_dekad_element_spi_era5(e.value);
    setSpiEra5SelectedDates(prev => ({
      ...prev,
      timescale: e.value
    }));
    handle_geoserver_link_spi_era5({...spi_era5_selected_dates, timescale: e.value})
  };
  const onchange_dekad_spi_era5 = (e) => {
    setSpiEra5SelectedDates(prev => ({
      ...prev,
      dekad: e.value
    }));
    handle_geoserver_link_spi_era5({...spi_era5_selected_dates, dekad: e.value})
  };

  var spi_era5_dekad_parameters = {
    timename: "dekad",
    changefunc: onchange_dekad_spi_era5,
    active: spi_era5_dekad_active
  }

  const onchange_year_longrange_forecast = (e) => {
    setSelected_longrange_forecast_dates(prev => {
      const next = {
        ...prev,
        year: e.value
      };
      const longrange_forecast_geoserver_link = `${geoserver}${maplibre_str}${layer_name_longrange_forecast}&CQL_FILTER=year=${next.year} AND forecast_period='${next["period"]}'`;
      setCurrent_longrange_forecast({ longrange_forecast_geoserver: longrange_forecast_geoserver_link });
      return next;
    });
  };
  
  const onchange_period_longrange_forecast = (e) => {
    setSelected_longrange_forecast_dates(prev => {
      const next = { 
        ...prev,
        period: e.value
      };
      const longrange_forecast_geoserver_link = `${geoserver}${maplibre_str}${layer_name_longrange_forecast}&CQL_FILTER=year=${next["year"]} AND forecast_period='${next.period}'`;
      setCurrent_longrange_forecast({ longrange_forecast_geoserver: longrange_forecast_geoserver_link });
      return next;
    });
  };
   

  const handle_monthly_precipitation = (data) => {
    var monthly_precipitation_data = data?.gpcc_monthly_precipitation;
    var start_year_m_precip_data = monthly_precipitation_data?.start_year;
    var latest_year_m_precip_data = monthly_precipitation_data?.latest_year;
    var start_month_m_precip_data = monthly_precipitation_data?.start_month;
    var latest_month_m_precip_data = monthly_precipitation_data?.latest_month;
    var years_monthly_precipitation = get_custom_list(start_year_m_precip_data, latest_year_m_precip_data);
    var initial_months = get_custom_list(start_month_m_precip_data, latest_month_m_precip_data);
    initial_months = initial_months.map(getMonthName);
    setMonthly_precipitation_dates({
      year: years_monthly_precipitation,
      month: initial_months,
    });

   
    var selected_month = getMonthName(latest_month_m_precip_data);
    setSelectedprecipitation_monthly_dates({
      year: latest_year_m_precip_data,
      month: selected_month,
    });

    if (latest_year_m_precip_data === current_year && latest_month_m_precip_data === current_month-1){
      
      
      var layer = `${guess_monthly_precip_name}${months[selected_month]}`;
      
    }else{
      layer = `${layer_name_monthly_precipitation}${months[selected_month]}`;
    }

    if (latest_year_m_precip_data === current_year && latest_month_m_precip_data === current_month-2){
      layer = `${guess_monthly_precip_name}${months[selected_month]}`;
    }

    
    var monthly_gpcc_wms = `${geoserver}${maplibre_str}${layer}_view&CQL_FILTER=year=${latest_year_m_precip_data}`;

    var legend_url = handle_legend_url(layer, geoserver);

    setGpcc_monthly_precipitation_legend_url(legend_url);

    monthly_gpcc_wms = handle_wmslink(
      monthly_gpcc_wms,
      "corr_cell",
      selected_country,
      selected_region
    );

    setCurrent_monthly_precipitation_gpcc({
      monthly_precipitation_gpcc_geoserver: monthly_gpcc_wms,
    });
  };

  useEffect(() => {
    if (rs_data !== null) {
      set_innitial_selected(rs_data);
      var monthly_precipitation_data = rs_data?.gpcc_monthly_precipitation
      handle_monthly_precipitation(rs_data);

      setCurrent_unwdc({
        unwdc_geoserver: `${geoserver}${maplibre_str}${layer_name_unwdc}${months[selected_unwdc_dates["month"]]}${selected_unwdc_dates["timescale"]}_view&CQL_FILTER=year=${selected_unwdc_dates["year"]}`,
      });

      setMonthly_precipitation_api_data(monthly_precipitation_data);
      handle_dekad_element_spi_era5(spi_era5_selected_dates["timescale"]);
    }
  }, [rs_data, layer_name_monthly_precipitation]);


  const handleInfoClickSpi = () => {
    setDroughtModalVisibleSpi(!isDroughtModalVisibleSpi);
  
    if (!isDroughtModalVisibleSpi) { 
      setIsLoadingSpiInfo(true); 
      const url = `${base_url}/api/metadata/?dataset_id=spi`;
      get_data(url).then((data) => {
        setSpi_info(data[0]);
        setIsLoadingSpiInfo(false);
      }).catch(error => {
        console.error('Failed to fetch CDI info:', error);
        setIsLoadingSpiInfo(false); 
      });
    }
  };

  const handleInfoClickMonthlyPrecip = () => {
    setDroughtModalVisibleMonthlyPrecip(!isDroughtModalVisibleMonthlyPrecip);
  
    if (!isDroughtModalVisibleMonthlyPrecip) { 
      setIsLoadingMonPrecipInfo(true); 
      const url = `${base_url}/api/metadata/?dataset_id=monthly_precip`;
      get_data(url).then((data) => {
        setMonthlyPrecipInfo(data[0]);
        setIsLoadingMonPrecipInfo(false);
      }).catch(error => {
        console.error('Failed to fetch CDI info:', error);
        setIsLoadingMonPrecipInfo(false); 
      });
    }
  };

  const undwc_onInfoClick = ()=>{
    handleInfoClickGeneral(isDroughtModalVisibleUnwdc, setDroughtModalVisibleUnwdc, setUnwdc_isLoading, 
       setUnwdc_info, "undwc")
  }
  // spi era5 info click
  const spiEra5_onInfoClick = ()=>{
    handleInfoClickGeneral(isDroughtModalVisibleSpiEra5, setDroughtModalVisibleSpiEra5, setIsLoadingSpiEra5Info, 
       setSpiEra5Info, "spi_era5")
  }

  // long range forecast info click
  const longrangeForecast_onInfoClick = ()=>{
    handleInfoClickGeneral(isDroughtModalVisibleLongrangeForecast, setDroughtModalVisibleLongrangeForecast, setIsLoadingLongrangeForecastInfo, 
       setLongrange_forecast_info, "longrange_forecast")
  }



  return (
    <div className="indicator-module">
      <p className="Indicator-names">PRECIPITATION INDICATORS</p>

      <div className="selection-section">
        <div className="selection-section-header">
          <label className="switch">
            <input
              type="checkbox"
              defaultChecked={precipitation_check}
              onChange={oncheck_precipitation_check}
            />
            <span className="slider round"></span>
          </label>
          <p className="indicator-description">
            Standard Precipitation Index GPCC
          </p>
          {get_info_element(handleInfoClickSpi)}
        </div>

        {isDroughtModalVisibleSpi && (
  <>
        <DroughtIndicatorModal
        dataset={spi_info}
        isActive={isDroughtModalVisibleSpi}
        toggleModal={handleInfoClickSpi}
        isLoading={IsLoadingSpiInfo}
        />

  </>
)}      
{precipitation_check ? (
        <p
          style={{
            position: "relative",
            color: "#000000",
            fontSize: "10px",
            left: "5px",
            marginTop: "10px",
          }}
        >
          {selected_spi_dates["year"]}{" "}
          {selected_spi_dates["month"] +
            " TimeScale : " +
            selected_spi_dates["timescale"]}{" "}
        </p>
      ) : (
        <></>
      )}

      {rs_data !== null ? (
        <div className="selection-row">
          {get_select_element(
            customoptions,
            years_spi,
            onchange_year_spi,
            selected_spi_dates["year"],
            precipitation_check
          )}

          {get_select_element(
            customoptions,
            spi_dates["month"],
            onchange_month_spi,
            selected_spi_dates["month"],
            precipitation_check
          )}
          {get_select_element(
            customoptions,
            spi_dates["timescale"],
            onchange_time_scale_spi,
            selected_spi_dates["timescale"],
            precipitation_check
          )}
        </div>
      ) : (
        <></>
      )}


      </div>

      {/* SPI Era5 */}

    
        {selection_component(() =>oncheckGeneral(checked_spi_era5, setChecked_spi_era5), checked_spi_era5,
        spiEra5_onInfoClick, "SPI ERA5", 
        isDroughtModalVisibleSpiEra5, IsLoadingSpiEra5Info, 
        spiEra5Info, spi_era5_selected_dates, spi_era5_dates,
        onchange_year_spi_era5, onchange_month_spi_era5, onchange_timescale_spi_era5, "timescale",
       spi_era5_dekad_parameters
         )}
     
      
      {/* precipitation forecast  */}

      
        {selection_component(oncheck_unwdc, unwdc_check,
        undwc_onInfoClick, "Forecast Unusualy dry & Wet Conditions", 
        isDroughtModalVisibleUnwdc, unwdc_isLoading, 
        unwdc_info, selected_unwdc_dates, unwdc_forecast_dates,
        onchange_year_unwdc, onchange_month_unwdc, onchange_timescale_unwdc, "timescale",
         )}

      {/* Long range Precipitation forecast */}

         {selection_component_general_longrange(() => 
          oncheckGeneral(longrange_forecast_check, setLongrange_forecast_check)
         ,longrange_forecast_check,longrangeForecast_onInfoClick, "Long-range Precipitation Forecast",
         isDroughtModalVisibleLongrangeForecast, IsLoadingLongrangeForecastInfo, longrange_forecast_info,
          selected_longrange_forecast_dates, LongrangeForecast_dates, onchange_year_longrange_forecast, onchange_period_longrange_forecast, "period",
         )}

      {/* monthly preciptation  */}
      
      

      <div className="selection-section">
        <div className="selection-section-header">
          <label className="switch">
            <input
              type="checkbox"
              defaultChecked={monthly_precipitation_check}
              onChange={oncheck_monthly_precipitation}
            />
            <span className="slider round"></span>
          </label>
          <p className="indicator-description">
            Monthly Precipitation
          </p>
          {get_info_element(handleInfoClickMonthlyPrecip)}
        </div>

        {isDroughtModalVisibleMonthlyPrecip && (
          <>
                <DroughtIndicatorModal
                dataset={monthlyPrecipInfo}
                isActive={isDroughtModalVisibleMonthlyPrecip}
                toggleModal={handleInfoClickMonthlyPrecip}
                isLoading={IsLoadingMonPrecipInfo}
                />

          </>
        )}

        {monthly_precipitation_check ? (
          <p
            style={{
              position: "relative",
              color: "#000000",
              fontSize: "10px",
              left: "5px",
              marginTop: "10px",
             
            }}
          >
            {selected_precipitation_monthly_dates["year"]}{" "}
            {selected_precipitation_monthly_dates["month"]}{" "}
          </p>
        ) : (
          <></>
        )}

      

        <div className="selection-row">
          {get_select_element(
            customoptions,
            monthly_precipitation_dates["year"],
            onchange_year_monthly_precipitation,
            selected_precipitation_monthly_dates["year"],
            monthly_precipitation_check
          )}

          {get_select_element(
            customoptions,
            monthly_precipitation_dates["month"],
            onchange_month_monthly_precipitation,
            selected_precipitation_monthly_dates["month"],
            monthly_precipitation_check
          )}
        </div>
      </div>

      <div className="tabs is-centered">
        <ul>
         
        </ul>
      </div>
    </div>
  );
};

export default Precipitation;
